<template>
  <div class="row padding40" style="margin-top: -10px">
    <div class="col-md-3 col-sm-2 col-xs-0"></div>
    <div
      class="col-md-6 col-sm-8 col-xs-12"
      v-if="form.organization.innError || markModelError"
    >
      <span style="color: #a94442">
        <strong>
          <i class="fa fa-times"></i>
        </strong>
        Подача заявки невозможна.
      </span>
      Обнаруженные проблемы:
      <ol>
        <li v-if="form.organization.innError">
          <span>
            <a href="#form-organization-inn">ИНН заявителя</a>
          </span>
        </li>
        <li v-if="disabledSubmitButton">
          <span>Наименование организации посетителя не должно совпадать с наименованием в секции "Заявитель":</span>
          <ul style="padding-left: 20px">
            <li v-for="(visitor, index) in form.visitors" v-bind:key="index">
              <template v-if="visitor.personal.visitorOrganizationErr">
                <a :href="`#form-visitor-organization-name-${index}`">
                  {{ visitor.personal.fullname_last ? visitor.personal.fullname_last : 'Посетитель' }}
                  {{ visitor.personal.fullname_first ? visitor.personal.fullname_first : '№' + (index + 1) }}
                  {{ visitor.personal.fullname_patronymic ? visitor.personal.fullname_patronymic : '' }}
                </a>
              </template>
            </li>
          </ul>
        </li>
        <li v-if="markModelError">
          <span>Марка и модель транспортного средства не должны быть одинаковыми:</span>
          <ul style="padding-left: 20px">
            <li v-for="(visitor, visitorKey) in form.visitors" v-bind:key="visitorKey">
              <template
                v-if="visitor.transports.length > 0 && visitor.transports[0] !== 'pedestrian' && visitor.transports.find(currentValue => currentValue['errorMarkModel'])"
              >
                {{ visitor.personal.fullname_last ? visitor.personal.fullname_last : 'Посетитель' }}
                {{ visitor.personal.fullname_first ? visitor.personal.fullname_first : (visitor.personal.fullname_last ? '' : '№' + (visitorKey + 1)) }}
                {{ visitor.personal.fullname_patronymic ? visitor.personal.fullname_patronymic : '' }}
                <ul style="padding-left: 20px">
                  <li
                    v-for="(transport, transportKey) in visitor.transports"
                    v-bind:key="transportKey"
                  >
                    <template v-if="transport.errorMarkModel">
                      <a :href="`#form-visitor-transport-model-${visitorKey}-${transportKey}`">
                        Транспортное средство
                        {{ transport.number ? transport.number : '№' + (transportKey + 1) }}
                      </a>
                    </template>
                  </li>
                </ul>
              </template>
            </li>
          </ul>
        </li>
      </ol>
    </div>
    <div class="col-md-3 col-sm-2 col-xs-0"></div>
  </div>
</template>

<script>
import applicationFormContextMixin from '../../../mixins/applicationFormContextMixin'

export default {
  name: 'PassErrorsBlock',
  mixins: [
    applicationFormContextMixin
  ],

  props: {
    disabledSubmitButton: {
      type: Boolean,
      default: false
    },

    markModelError: {
      type: Boolean,
      default: false
    }
  }
}
</script>
